export default __webpack_public_path__ + "static/media/circle.133d352c.png";